<template>
  <div class="flex flex-col items-center bg-transparant text-primary">
    <a href="https://xs2event.com"><XS2EventLogo /></a>
  </div>
</template>

<script setup>
import XS2EventLogo from "@/components/media/XS2EventLogo.vue";
</script>
